import React from 'react'
import classNames from 'classnames'
import Modal from '../Shared/Modal'
import WizardForm from './WizardForm'

const NewAppModal = ({ className, ...otherProps }) => (
  <Modal className={classNames('new-app-modal', className)} {...otherProps}>
    <WizardForm />
  </Modal>
)

export default NewAppModal
